import { createSelector } from 'reselect';
import { roundByRoundSelector } from './simple-selectors';

export const roundByRoundNavSelector = createSelector(
    roundByRoundSelector,
    (roundByRound) => roundByRound.nav
);
